// src/utils/imageUrls.js
// קובץ מרכזי לכל כתובות התמונות באתר

// ===============================
// HERO SECTION IMAGES
// ===============================
export const HERO_IMAGES = {
    logo: '/images/logo4.png',
    background: '/images/wood-working-2385634_1920.jpg',
    // כרטיסי ניווט ראשיים
    pergola: '/images/pergola6.jpg',
    homeFurniture: '/images/bench3.jpg',
    gardenFurniture: '/images/pinat.jpg',
    ourProjects: '/images/flag.jpeg'
};

// ===============================
// HOME FURNITURE IMAGES
// ===============================
export const HOME_FURNITURE_IMAGES = {
    decorativeBench: '/images/decorative-Bench/bench3.jpg', // decorativeBench2 בקוד המקורי
    homeTable: '/images/table/table7.jpg',
    bed: '/images/bed/bed1.jpg',
    cabinet: '/images/cabinet/cabinet3.jpg',
    shelves: '/images/shelves.jpeg',
    rack: '/images/rack.jpeg',
    wallCovering: '/images/wall-covering/wallCovering2.jpg',
    woodHolder: '/images/wood-holder/wood-holder1.jpg',
    dresser: '/images/types/dresser.jpg',

    // גלריות (בהתאם לקוד המקורי)
    decorativeBenchGallery: [
        '/images/decorative-Bench/bench4.jpg', // decorativeBench בקוד המקורי
        '/images/decorative-Bench/bench3.jpg', // decorativeBench2 בקוד המקורי
        '/images/decorative-Bench/bench2.jpg'  // decorativeBench1 בקוד המקורי
    ],
    homeTableGallery: [
        '/images/table/table5.jpg', // homeTable בקוד המקורי
        '/images/table/table1.jpg'  // homeTable1 בקוד המקורי
    ],
    bedGallery: [
        '/images/bed/bed2.jpg',  // bedImage1 בקוד המקורי
        '/images/bed/bed1.jpg',  // bedImage2 בקוד המקורי
        '/images/bed/bed6.jpg',  // bedImage3 בקוד המקורי
        '/images/bed/bed3.jpg'   // bedImage4 בקוד המקורי
    ],
    cabinetGallery: [
        '/images/cabinet/Cabinet.jpg',   // Cabinet בקוד המקורי
        '/images/cabinet/Cabinet1.jpg'   // Cabinet1 בקוד המקורי
    ],
    shelvesGallery: [
        '/images/cabinet/shelves.jpg',
        '/images/cabinet/shelves1.jpg',
        '/images/cabinet/shelves2.jpg',
        // '/images/cabinet/shelves4.jpg',
        '/images/cabinet/shelves5.jpg',
        '/images/cabinet/shelves6.jpg'
    ],
    rackGallery: [
        '/images/types/rack.jpg'  // rack1 בקוד המקורי
    ],
    wallCoveringGallery: [
        '/images/wall-covering/wallCovering2.jpg',
        '/images/wall-covering/wall-covering.jpg',
        '/images/wall-covering/wall-covering1.jpg'
    ],
    woodHolderGallery: [
        '/images/wood-holder/wood-holder1.jpg',
        '/images/wood-holder/wood-holder.jpg'
    ],
    dresserGallery: [
        '/images/types/dresser.jpg'
    ]
};

// ===============================
// GARDEN FURNITURE IMAGES
// ===============================
export const GARDEN_FURNITURE_IMAGES = {
    // תמונות ראשיות
    bench: '/images/bench/bench3.jpeg',
    table: '/images/table/table.jpg',
    swing: '/images/swing/swing5.jpg',
    seatingArea: '/images/seatingArea/seatingArea1.jpg',
    woodHolder: '/images/wood-holder/wood-holder1.jpg',

    // גלריות
    benchGallery: [
        '/images/bench/bench.jpg',
        '/images/bench/bench2.jpg',
        '/images/bench/bench1.jpg'
    ],
    tableGallery: [
        '/images/table/table.jpg',
        '/images/table/table2.jpg',
        '/images/table/table3.jpg',
        '/images/table/table4.jpg',
        '/images/table/table5.jpg',
        '/images/table/table7.jpg'
    ],
    swingGallery: [
        '/images/swing/swing.jpg',
        '/images/swing/swing1.jpg',
        '/images/swing/swing2.jpg',
        '/images/swing/swing3.jpg',
        '/images/swing/swing4.jpg',
        '/images/swing/swing5.jpg'
    ],
    seatingAreaGallery: [
        '/images/seatingArea/pinat.jpg',
        '/images/seatingArea/seatingArea1.jpg',
        '/images/seatingArea/seatingArea.jpg'
    ],
    woodHolderGardenGallery: [
        '/images/wood-holder/wood-holder.jpg'
    ]
};

// ===============================
// PERGOLAS AND DECKS IMAGES
// ===============================
export const PERGOLAS_DECKS_IMAGES = {
    // תמונות ראשיות
    playHouse: '/images/playHouse/wood-house.jpg',
    pergola: '/images/pergola/pergola7.jpeg',
    fence: '/images/fence/fence4.jpg',
    deck: '/images/deck/deck3.jpeg',

    playHouseGallery: [
        '/images/playHouse/wood-hous-2.jpg', // playHouse4 בקוד המקורי
        '/images/playHouse/wood-house.jpg',  // playHouse3 בקוד המקורי
        '/images/playHouse/playHouse.jpg',   // playHouse1 בקוד המקורי
        '/images/playHouse/playHouse1.jpg'   // playHouse2 בקוד המקורי
    ],
    pergolaGallery: [
        '/images/pergola/pergola1.jpg',  // pergola בקוד המקורי
        '/images/pergola/pergola7.jpeg',  // pergola1 בקוד המקורי
        '/images/pergola/pergola8.jpeg',
        '/images/pergola/pergola9.jpeg',// pergola2 בקוד המקורי
        '/images/pergola/pergola4.jpg',  // pergola3 בקוד המקורי
        '/images/pergola/pergola5.jpg',  // pergola4 בקוד המקורי
        '/images/pergola/pergola6.jpg'   // pergola5 בקוד המקורי
    ],
    fenceGallery: [
        '/images/fence/fence.jpg',   // fence בקוד המקורי
        '/images/fence/fence1.jpg',  // fence1 בקוד המקורי
        '/images/fence/fence2.jpg',  // fence2 בקוד המקורי
        '/images/fence/fence4.jpg',  // fence3 בקוד המקורי (הסדר שונה!)
        '/images/fence/fence5.jpg',  // fence4 בקוד המקורי
        '/images/fence/fence6.jpg',  // fence5 בקוד המקורי
        '/images/fence/fence7.jpg',  // fence6 בקוד המקורי
        '/images/fence/fence3.jpg'   // fence7 בקוד המקורי (הסדר שונה!)
    ],
    deckGallery: [
        '/images/deck/deck.jpg',   // deck בקוד המקורי
        '/images/deck/deck1.jpg',  // deck1 בקוד המקורי
        '/images/deck/deck2.jpg',  // deck2 בקוד המקורי
        '/images/deck/deck3.jpg'   // deck3 בקוד המקורי
    ]
};

// ===============================
// OFFERS IMAGES
// ===============================
export const OFFERS_IMAGES = {
    // תמונות ראשיות של חבילות
    packageTable: '/images/package-table-swing.jpg',   // package1Image בקוד המקורי
    packageGarden: '/images/package-garden.webp',      // package3Image בקוד המקורי

    // תמונות נוספות לחבילות (בהתאם לקוד המקורי)
    packageTableGallery: [
        '/images/swing/swing5.jpg',   // swing5 בקוד המקורי
        '/images/table/table.jpg',   // table בקוד המקורי
        '/images/bench/bench2.jpg'   // bench1 בקוד המקורי
    ],
    packageGardenGallery: [
        '/images/table/table.jpg',   // table בקוד המקורי
        '/images/bench/bench2.jpg',  // bench1 בקוד המקורי
        '/images/bench/bench1.jpg'   // bench2 בקוד המקורי
    ]
};

// ===============================
// OUR PROJECTS IMAGES
// ===============================
export const OUR_PROJECTS_IMAGES = {
    gardenPlanters: '/images/garden-planters/garden-planters.jpg',     // gardenPlanters בקוד המקורי
    gardenPlanters1: '/images/garden-planters/garden-planters1.jpg',   // gardenPlanters1 בקוד המקורי
    gardenPlanters3: '/images/garden-planters/garden-planters3.jpg',   // gardenPlanters6 בקוד המקורי
    storageBox: '/images/types/storge-box.jpg',                        // gardenPlanters8 בקוד המקורי
    storageBox1: '/images/types/storge-box1.jpg',                      // gardenPlanters7 בקוד המקורי
    playHouse: '/images/playHouse/wood-house.jpg'
};

// ===============================
// ABOUT US IMAGES
// ===============================
export const ABOUT_US_IMAGES = {
    companyImage: '/images/garden-planters/garden-planters3.jpg'
};

// ===============================
// HELPER FUNCTIONS
// ===============================

// פונקציה לקבלת תמונה עם fallback
export const getImage = (imagePath, fallback = '/images/placeholder.jpg') => {
    return imagePath || fallback;
};

// פונקציה לקבלת גלריה עם filtering של תמונות ריקות
export const getGallery = (galleryArray) => {
    if (!Array.isArray(galleryArray)) return [];
    return galleryArray.filter(img => img && img.trim() !== '');
};

// פונקציה לחיפוש תמונה לפי שם
export const findImageByName = (imageName) => {
    const allImages = {
        ...HERO_IMAGES,
        ...HOME_FURNITURE_IMAGES,
        ...GARDEN_FURNITURE_IMAGES,
        ...PERGOLAS_DECKS_IMAGES,
        ...OFFERS_IMAGES,
        ...OUR_PROJECTS_IMAGES,
        ...ABOUT_US_IMAGES
    };

    const foundKey = Object.keys(allImages).find(key =>
        key.toLowerCase().includes(imageName.toLowerCase())
    );

    return foundKey ? allImages[foundKey] : '/images/placeholder.jpg';
};